import { ErrorResponse, Timestamp, TuettuKieli } from '@lemon/core/model/common'
import { EmailLahetysStatus } from './lasku'

export interface KirjanpidonAineistonLatausTiedot {
  aineistonLatausSessionAvain: string
  downloadUrl: string
}

export interface VahvistaAineistonLatausRequest {
  aineistonLatausSessionAvain: string
}

export interface VahvistaAineistonLatausResponse extends ErrorResponse<'error'> {}

export enum KirjanpidonLadattavanAineistonTila {
  PROSESSOIDAAN = 'p',
  TARKISTETAAN = 't',
  OK = 'o',
  VIRHEELLINEN = 'v',
}

export enum KirjanpidonLadattavanAineistonTyyppi {
  KIRJANPITAJAN_TILAAMA = 'k',
}

/**
 * HTTPS-virheet, jotka käsitellään käyttöliittymässä
 */
export enum AineistonLatausVirhe {
  LADATTU = 'l',
  VOIMASSAOLO_PAATTYNYT = 'vp',
}

export interface KirjanpidonLadattavaAineistoVastaanottaja {
  kayttajaAvain: string
  emailStatus: EmailLahetysStatus
}

/**
 * Zipin luominen
 * 1. Kirjoita työjono entry oikeaan paikkaan + listausdata entryn
 * 2. Ensimmäinen työjono luo zipin, muuttaa tilan listausdatassa, siirtää tyojonon eteenpäin
 * 3. Toinen työjono handler tarkistaa zipin, muuttaa tilan listausdatassa, poistaa tyojonon. (Retry -> poista epäonnistunut, luo uusi + työjonoentry alkuun, max 5 kierrosta?)
 *
 * Lataaminen
 * 4. Käyttäjä klikkaa listausdataa -> lähetä CF:lle pyynto. Vastaa signatulla CS urlilla
 * 5. Lataa tiedosto suoraan
 *
 * Asiakkaalle lähettäminen
 * 6. Luodaan taikalinkki, joka lähetetään vastaanottajille (Yhteyshenkilö-roolilliset) ja jonka avulla latauksen voi suorittaa Lemonaidissa
 * 7. Kun ladattu ja kuitattu vastaanotetuksi, tallennetaan kuittaus dataan (jos ei kuitattu, näkyy tunnistautumis-datassa luodut latauslinkit)
 */
// customers/{asiakasAvain}/downloadable-accounting-material/{materialAvain}
export interface KirjanpidonLadattavaAineisto {
  /**
   * Milloin työ luotiin (Created)?
   */
  c: Timestamp
  /**
   * Missä tilasssa aineisto on?
   */
  b: KirjanpidonLadattavanAineistonTila
  /**
   * Milloin työ valmistui?
   */
  v: Timestamp
  /**
   * Tyyppi
   */
  t: KirjanpidonLadattavanAineistonTyyppi
  /**
   * Asiakkaan avain
   */
  a: string
  /**
   * Aineiston alkamispäivä yymmdd
   */
  s: number
  /**
   * Aineiston loppumispäivä yymmdd
   */
  e: number
  /**
   * Aineiston kieli
   */
  k: TuettuKieli
  /**
   * Ladattavan aineiston avain
   */
  l: string
  /**
   * Aineiston tilannut käyttäjä
   */
  u: string
  /**
   * Lähetetty asiakkaalle
   */
  lahetettyAsiakkaalle?: Timestamp
  /**
   * Aineiston lähetyksen tilannut käyttäjä
   */
  lahettanytAsiakkaalle?: string
  /**
   * Aineiston latauksen vastaanottajat (eli sallitut lataajat)
   */
  vastaanottajat?: KirjanpidonLadattavaAineistoVastaanottaja[]
  /**
   * Asiakkaalle toimitettavan taikalinkin avain
   */
  linkinAvain?: string
  /**
   * Milloin latauksen voimassaolo päättyy
   */
  voimassaoloPaattyy?: Timestamp
  /**
   * Lokitus luoduille linkeille vahvistetun tunnistautumisen jälkeen
   */
  tunnistautumiset?: {
    [aineistonLatausSessionAvain: string]: {
      // AineistonLatausSessio:sta löytyy lisätiedot
      suoritettu: Timestamp
      linkki: string
    }
  }
  /**
   * Aikaleima asiakkaan kuittaukselle
   */
  kuitattuNoudetuksi?: Timestamp
  /**
   * Kuittauksen session avain (AineistonLatausSessio)
   */
  kuittauksenAineistonLatausSessionAvain?: string
  /**
   * Käyttäjän UID, joka kuitannut
   */
  kuittaaja?: string
}

export interface KirjanpidonLadattavaAineistoHistoria extends KirjanpidonLadattavaAineisto {
  paivitetty: Timestamp
}
